/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Update the top users
 *
 * @param  {Object} state
 * @return {Void}
 */
const SET_TOP_USERS = (state, data) => {
    state.topUsers = data
}

/**
 * Update the geolocation data
 *
 * @param  {Object} state
 * @return {Void}
 */
const SET_GEOLOCATION = (state, data) => {
    state.geolocation = data
}

/**
 * Set the histogram data
 *
 * @param  {Object} state
 * @return {Void}
 */
const SET_HISTOGRAM = (state, data) => {
    state.histogram.data = data
}

/**
 * Set the general activity data
 *
 * @param  {Object} state
 * @return {Void}
 */
const SET_ACTIVITY = (state, data) => {
    state.activity.data = data.data
    state.activity.meta = data.meta
}

/**
 * Set the histogram key
 *
 * @param  {Object} state
 * @param  {String} key
 * @return {Void}
 */
const CHANGE_HISTOGRAM_KEY = (state, key) => {
    state.histogram.type = key
}

/**
 * Set the load state
 *
 * @param  {Object} state
 * @return {Void}
 */
const LOADING_COMPLETED = (state) => {
    state.loaded = true
}

/**
 * Update the context state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const UPDATE_CONTEXT = (state, payload) => {
    state.context = payload
}

export default {
    RESET_STATE,
    SET_ACTIVITY,
    SET_TOP_USERS,
    SET_HISTOGRAM,
    UPDATE_CONTEXT,
    SET_GEOLOCATION,
    LOADING_COMPLETED,
    CHANGE_HISTOGRAM_KEY
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/activity/mutations.js